var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.329,
    height: 76.316,
    viewBox: "0 0 76.329 76.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-play-765172",
    transform: "translate(-152.25 -152.35)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10567",
    "data-name": "Path 10567",
    d: "M190.417,152.35a38.158,38.158,0,1,0,38.162,38.162A38.207,38.207,0,0,0,190.417,152.35Zm35.311,38.158A35.311,35.311,0,1,1,190.417,155.2,35.349,35.349,0,0,1,225.727,190.508Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10568",
    "data-name": "Path 10568",
    d: "M499.175,439.952l-26.1-13.046a1.762,1.762,0,0,0-2.579,1.6v25.973a1.751,1.751,0,0,0,1.735,1.8,1.934,1.934,0,0,0,.848-.2l26.088-13.055a1.678,1.678,0,0,0,0-3.073Zm-3.307,1.539-22.512,11.256V430.239Z",
    transform: "translate(-291.123 -250.983)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/videoPlay.53ade102f0eab185baa0170b17389459.svg";
export { ForwardRef as ReactComponent };